export default {"src":"/_next/static/media/review-star.69295250.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};